import api from "../api";

export interface PanicReport {
  id: number;
  booking_id: number;
  user_id: number;
  latitude: number;
  longitude: number;
  reason?: string;
  status: "pending" | "reviewing" | "resolved";
  created_at: string;
}

class PanicService {
  async reportPanic(data: {
    booking_id: number;
    latitude: number;
    longitude: number;
    reason?: string;
  }): Promise<PanicReport> {
    const response = await api.post("/panic/report", data);
    return response.data.data;
  }

  async getReports(): Promise<PanicReport[]> {
    const response = await api.get("/panic/reports");
    return response.data.data;
  }
}

export default new PanicService();
